import { Children, isValidElement } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import type { SwiperProps, SwiperSlideProps } from 'swiper/react'
import SwiperCore, { Autoplay, EffectFade, Mousewheel, Navigation, Pagination, Scrollbar } from 'swiper'
import SliderArrows from './SliderArrows'

SwiperCore.use([Navigation, Mousewheel, Autoplay, EffectFade, Pagination, Scrollbar])

type Props = SwiperProps & { arrowLabel?: string }

/** Slide shells stay dependency-free until their actual Swiper branch is rendered. */
const SwiperSlider = ({ children, arrowLabel, ...props }: Props) => <Swiper {...props}>
  {Children.map(children, child => isValidElement<SwiperSlideProps>(child)
    ? <SwiperSlide {...child.props} />
    : child)}
  {arrowLabel && <SliderArrows label={arrowLabel} />}
</Swiper>

export default SwiperSlider
